import styled from 'styled-components';

import { TotemLabel } from 'components/TotemLabel';
import { NotificationPreferenceRow } from './NotificationPreferenceRow';

import { GetUserQuery, NotificationPreferenceChannel } from 'data/__generated__';

export const NotificationPreferencesDetails = ({
    notificationPreferences,
    userId,
}: {
    notificationPreferences: NonNullable<GetUserQuery['userFromAdmin']>['notificationPreferences'];
    userId: string;
}) => {
    return (
        <Container>
            <TotemLabel>Préférences de notifications</TotemLabel>
            <table>
                <thead>
                    <tr>
                        <th>Catégorie</th>
                        <th>Mail</th>
                        <th>Push</th>
                        <th>InApp</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(notificationPreferences)
                        .filter(([key]) => key !== '__typename')
                        .map(([category, channels]) => (
                            <NotificationPreferenceRow
                                key={category}
                                category={category}
                                channels={channels as NotificationPreferenceChannel[]}
                                userId={userId}
                            />
                        ))}
                </tbody>
            </table>
        </Container>
    );
};

const Container = styled.div`
    color: ${({ theme }) => theme.textColor};
`;
